/**
 * The player the launcher hands over.
 *
 * On this RGS the uuid inside the launch key *is* the account, so minting one is
 * free and no registration exists to do it through. It is kept across reloads
 * because a balance is only worth watching if it survives one.
 *
 * Rotating it is the documented way out of a round the client cannot finish —
 * the server refuses to start a round while the previous one is open, and a
 * free-spin trigger the game cannot complete leaves one open forever.
 */

const STORAGE_KEY = 'reeldesk.playerId'

export function newPlayerId(): string {
  const id = crypto.randomUUID()
  localStorage.setItem(STORAGE_KEY, id)
  return id
}

export function storedPlayerId(): string {
  return localStorage.getItem(STORAGE_KEY) ?? newPlayerId()
}
